const data = {
  'Selected': 'Ausgewählt: {0} von {1}',
  'Uploading files': 'Hochladen: {0}% von {1}',
  'File size error': '{0} ist zu groß, bitte nur Dateien hochladen die kleiner als {1} sind.',
  'Upload failed': '{0} wurde(n) nicht hochgeladen',
  'Per page': '{0} pro Seite',
  'Folder': 'Ordner',
  'Login failed, please try again': 'Anmeldung fehlgeschlagen, bitte nochmal versuchen.',
  'Already logged in': 'Bereits angemeldet',
  'Please enter username and password': 'Bitte Benutername und Passwort eingeben.',
  'Not Found': 'Nicht gefunden',
  'Not Allowed': 'Not Allowed',
  'Please log in': 'Bitte anmelden',
  'Unknown error': 'Unbekannter Fehler',
  'Add files': 'Dateien hinzufügen',
  'New': 'New',
  'New name': 'Neuer Name',
  'Username': 'Benutzername',
  'Password': 'Passwort',
  'Login': 'Anmelden',
  'Logout': 'Abmelden',
  'Profile': 'Profil',
  'No pagination': 'Kein Seitenumbruch',
  'Time': 'Zeitpunkt',
  'Name': 'Name',
  'Size': 'Größe',
  'Home': 'Home',
  'Copy': 'Kopieren',
  'Move': 'Verschieben',
  'Rename': 'Umbenennen',
  'Required': 'Bitte dieses Feld ausfüllen',
  'Zip': 'Zip',
  'Batch Download': 'Batch Download',
  'Unzip': 'Entpacken',
  'Delete': 'Löschen',
  'Download': 'Herunterladen',
  'Copy link': 'Link kopieren',
  'Done': 'Fertig',
  'File': 'Datei',
  'Drop files to upload': 'Dateien zum Hochladen hier ablegen',
  'Close': 'Schließen',
  'Select Folder': 'Ordner auswählen',
  'Users': 'Benutzer',
  'Files': 'Dateien',
  'Role': 'Rolle',
  'Cancel': 'Abbrechen',
  'Paused': 'Pausiert',
  'Confirm': 'Bestätigen',
  'Create': 'Erstellen',
  'User': 'Benutzer',
  'Admin': 'Admin',
  'Save': 'Speichern',
  'Read': 'Lesen',
  'Write': 'Schreiben',
  'Upload': 'Hochladen',
  'Permissions': 'Berechtigungen',
  'Homedir': 'Home Ordner',
  'Leave blank for no change': 'Leer lassen um keine Änderung vorzunehmen',
  'Are you sure you want to do this?': 'Bist du sicher, dass du das tun willst?',
  'Are you sure you want to allow access to everyone?': 'Sind Sie sicher, dass Sie jedem den Zugang ermöglichen wollen?',
  'Are you sure you want to stop all uploads?': 'Bist du sicher, dass du alle Uploads stoppen willst?',
  'Something went wrong': 'Etwas ist schief gelaufen',
  'Invalid directory': 'Ungültiges Verzeichniss',
  'This field is required': 'Dieses Feld ist erforderlich',
  'Username already taken': 'Benutzername bereits vergeben',
  'User not found': 'Benutzer nicht gefunden',
  'Old password': 'Altes Passwort',
  'New password': 'Neues Passwort',
  'Wrong password': 'Falsches Passwort',
  'Updated': 'Aktualisiert',
  'Deleted': 'Gelöscht',
  'Your file is ready': 'Deine Datei ist fertig',
  'View': 'View',
  'Search': 'Search',
  'Download permission': 'Herunterladen',
  'Guest': 'Guest',
  'Show hidden': 'Verborgenes zeigen',
}

export default data
